<template>
    <article id="profile-page">
        <div class="logo">
            <a href="/"><img src="/static/mixsii-logo.svg"/></a>
            <h1>Free Video Chat Rooms</h1>
            <h1><a href="/Chat">Chat Now!</a></h1>
        </div>

        <div class="loader-container" v-if="fetchingProfileData">
            <loader-large></loader-large>
        </div>

        <template v-if="!fetchingProfileData">
            <section class="profile-content">
                <div v-if="errors.length > 0" class="validation error">
                    <span v-for="error in errors">{{error}}</span>
                </div>

                <template v-if="errors.length === 0">
                    <div class="details">
                        <img class="avatar" :src="avatarImage"/>

                        <div class="delete-friend-form" v-if="deleteFriendMode">
                            <h1>Really Delete?</h1>
                            <button @click.prevent="removeFriend">Yes!</button>
                            <button @click.prevent="deleteFriendMode = false">Cancel</button>
                        </div>

                        <div class="edit-stats" v-if="editProfileMode">
                            <div class="stats-properties">
                                <label>
                                    <span>Name</span>
                                    <input type="text" v-model="editDetails.realName"/>
                                </label>

                                <label>
                                    <span>Location</span>
                                    <input type="text" v-model="editDetails.location"/>
                                </label>

                                <label>
                                    <span>Share Age</span>
                                    <input type="checkbox" v-model="editDetails.showAge"/>
                                </label>

                                <label v-if="editDetails.showAge">
                                    <span>Birthday</span>
                                    <span class="select-container">
                                        <select v-model="editDetails.birthMonth">
                                            <option value="1">Jan</option>
                                            <option value="2">Feb</option>
                                            <option value="3">Mar</option>
                                            <option value="4">Apr</option>
                                            <option value="5">May</option>
                                            <option value="6">June</option>
                                            <option value="7">July</option>
                                            <option value="8">Aug</option>
                                            <option value="9">Sep</option>
                                            <option value="10">Oct</option>
                                            <option value="11">Nov</option>
                                            <option value="12">Dec</option>
                                        </select>

                                        <select v-model="editDetails.birthDay">
                                            <option v-for="n in 31" :value="n">{{n}}</option>
                                        </select>

                                        <select v-model="editDetails.birthYear">
                                            <option v-for="n in yearRange(1900)" :value="n">{{n}}</option>
                                        </select>
                                    </span>
                                </label>

                                <label>
                                    <span>Gender</span>

                                    <div class="sub-label">
                                        <label>
                                            <span>Male</span>
                                            <input type="radio" v-model="editDetails.gender" value="Male">
                                        </label>

                                        <label>
                                            <span>Female</span>
                                            <input type="radio" v-model="editDetails.gender" value="Female">
                                        </label>
                                    </div>
                                </label>

                                <label>
                                    <span>Share Height</span>
                                    <input type="checkbox" v-model="editDetails.showHeight"/>
                                </label>

                                <label v-if="editDetails.showHeight">
                                    <span>Height</span>

                                    <span class="select-container" v-if="!useMetric">
                                        <select v-model="editDetails.heightFeet">
                                            <option v-for="n in 6" :value="n">{{n}}'</option>
                                        </select>

                                        <select v-model="editDetails.heightInches">
                                            <option v-for="n in 11" :value="n">{{n}}"</option>
                                        </select>
                                    </span>

                                    <input type="text" v-if="useMetric" placeholder="Height in cm" v-model="editDetails.metricHeight"/>
                                </label>
                            </div>

                            <button @click.prevent="saveProfileData">Save</button>
                        </div>

                        <div class="stats" v-if="!deleteFriendMode && !editProfileMode">

                            <div class="stats-properties">
                                <span class="alias" v-if="profileData.alias">{{profileData.alias}}</span>
                                <span v-if="profileData.realName">{{profileData.realName}}</span>
                                <span v-if="profileData.location">{{profileData.location}}</span>
                                <span v-if="compoundStats">{{compoundStats}}</span>
                                <span v-if="profileData.registrationDate">Member since {{profileData.registrationDate | formatDateWithoutTime}}</span>
                            </div>

                            <template v-if="retrievedFriendStatus">
                                <button v-if="buttonToUse === 'addFriend'"
                                        @click.prevent="addFriend"
                                        :disabled="isUpdatingFriendStatus"
                                >Add Friend
                                </button>

                                <button v-if="buttonToUse === 'removeFriend'"
                                        @click.prevent="deleteFriendMode = true"
                                        :disabled="isUpdatingFriendStatus"
                                >Remove Friend
                                </button>

                                <button v-if="buttonToUse === 'friendRequestSent'"
                                        disabled
                                >Friend Request Pending
                                </button>

                                <button v-if="buttonToUse === 'acceptFriend'"
                                        @click.prevent="acceptFriendRequest"
                                        :disabled="isUpdatingFriendStatus"
                                >Accept Friend Request
                                </button>

                                <button v-if="buttonToUse === 'editProfile'"
                                        @click.prevent="editProfileMode = true"
                                >Edit Profile
                                </button>

                            </template>
                        </div>
                        <div class="ad-container">
                            <ad-container ad-slot="6967449791"></ad-container>
                        </div>
                    </div>

                    <photo-manager :photos="profileData.photos" :is-own-profile="isOwnProfile" :memberId="profileData.id"></photo-manager>

                    <h1 v-if="profileData.bio || isOwnProfile">Bio</h1>
                    <pre v-if="!editBioMode && profileData.bio" class="bio">{{profileData.bio}}</pre>

                    <textarea v-if="editBioMode" class="edit-bio-content" v-model="editBioContent" maxlength="600"></textarea>

                    <button v-if="isOwnProfile && !editBioMode" class="edit-bio-button" @click.prevent="editBioMode = true">Edit Bio</button>
                    <button v-if="isOwnProfile && editBioMode" class="edit-bio-button" @click.prevent="saveBio">Save Bio</button>

                    <div class="large-ad">
                        <ad-container ad-slot="2462240339"></ad-container>
                    </div>

                    <browse-more-profiles :current-member-id="profileData.id"></browse-more-profiles>
                </template>
            </section>
        </template>

        <footer>Mixsii is a Free Video Chat Room Service, with a list of chat rooms. HD Video Chat with friends, family, and strangers completely free from your web browser. No download required to make it work! Group calls and Video Conferencing is available. Browse the list of video chat rooms for teen, adults, and enthusiasts. Mixsii is cross-browser, and even works on Android and iOS Apple Devices.</footer>
    </article>
</template>

<script>
    import axios from 'axios';
    import BrowseMoreProfiles from './BrowseMoreProfiles.vue'
    import PhotoManager from './PhotoManager.vue'
    import AdContainer from '../Common/AdContainer.vue'

    export default {
        name: 'ProfilePage',

        components: {
            'browse-more-profiles': BrowseMoreProfiles,
            'photo-manager': PhotoManager,
            'ad-container': AdContainer
        },

        data() {
            return {
                errors: [],
                fetchingProfileData: true,
                profileData: {},
                isUpdatingFriendStatus: false,
                retrievedFriendStatus: false,
                friendStatus: '',
                deleteFriendMode: false,
                editProfileMode: false,
                editDetails: {},
                editBioContent: '',
                editBioMode: false
            }
        },

        computed: {
            compoundStats(){
                let stats = [];
                if (this.profileData.gender !== 'nospec') {
                    stats.push(this.profileData.gender);
                }

                if (this.profileData.showAge) {
                    let birthdayDate = new Date();
                    birthdayDate.setFullYear(this.profileData.birthYear);
                    birthdayDate.setMonth(this.profileData.birthMonth);
                    birthdayDate.setDate(this.profileData.birthDay);
                    birthdayDate.setHours(0);
                    birthdayDate.setMinutes(0);
                    birthdayDate.setSeconds(0);

                    stats.push((new Date(Date.now() - birthdayDate.getTime()).getUTCFullYear() - 1970) + ' years old');
                }

                if (this.profileData.showHeight) {
                    if (this.useMetric) {
                        stats.push(this.metricHeight + 'cm tall');
                    } else {
                        stats.push(this.profileData.heightFeet + '\'' + this.profileData.heightInches + '" tall');
                    }
                }

                return stats.join(', ');
            },

            useMetric(){
                return this.$store.state.loggedUserModel.isLoggedIn
                    ? this.$store.state.loggedUserModel.info.useMetric
                    : false;
            },

            metricHeight(){
                let cm = ((this.profileData.heightFeet * 12) + this.profileData.heightInches) * 2.54;
                cm = Math.round(cm);

                return cm;
            },

            avatarImage(){
                let avatarId = new Date(this.profileData.avatarUpdate).getTime();
                return this.profileData.hasAvatar
                    ? `/userdata/avatars/${this.profileData.id}.jpg?${avatarId}`
                    : '/defaultProfilePic.png';
            },

            isOwnProfile(){
                return this.$store.state.loggedUserModel.isLoggedIn && this.$store.state.loggedUserModel.info.stringUrl === this.$route.params.stringUrl;
            },

            buttonToUse(){
                if (this.isOwnProfile) {
                    return 'editProfile';
                }

                if (this.friendStatus === 'notFriends') {
                    return 'addFriend';
                }

                if (this.friendStatus === 'friends') {
                    return 'removeFriend';
                }

                if (this.friendStatus === 'friendRequestSent') {
                    return 'friendRequestSent'
                }

                if (this.friendStatus === 'friendRequestReceived') {
                    return 'acceptFriend'
                }

                return ''

            }
        },

        methods: {
            fetchProfileData(callback){
                let stringUrl = this.$route.params.stringUrl;

                axios.get('/api/member', {
                    params: {
                        stringUrl
                    }
                }).then(
                    (response) => {
                        this.fetchingProfileData = false;

                        if (response.data.errors) {
                            this.errors = response.data.errors;
                            if (callback) {
                                callback(false);
                            }
                            return;
                        }

                        this.profileData = response.data;

                        axios.post('/api/member/profileView', {
                            profileId: this.profileData.id
                        });

                        if (callback) {
                            callback(true);
                        }
                    },
                    (response) => {
                        this.errors = ['There was no response from the server. Please wait a minute and try again.'];
                        this.fetchingProfileData = false;

                        if (callback) {
                            callback(false);
                        }
                    }
                )
            },

            fetchFriendStatus(){
                axios.get('/api/friendStatus', {
                    params: {
                        friendId: this.profileData.id
                    }
                }).then(
                    (response) => {
                        if (response.data.errors) {
                            this.errors = response.data.errors;
                            return;
                        }

                        this.friendStatus = response.data.response;
                        this.retrievedFriendStatus = true;
                    },
                    (response) => {
                        this.errors = ['There was no response from the server. Please wait a minute and try again.'];
                    }
                )
            },

            addFriend(){
                this.isUpdatingFriendStatus = true;

                axios.post('/api/friendRequests/add', {
                    friendId: this.profileData.id
                }).then(
                    (response) => {
                        this.isUpdatingFriendStatus = false;
                    },
                    (response) => {
                        this.isUpdatingFriendStatus = false;
                    }
                )
            },

            acceptFriendRequest(){
                this.isUpdatingFriendStatus = true;

                axios.post('/api/friendRequests/accept', {
                    friendId: this.profileData.id
                }).then(
                    (response) => {
                        this.isUpdatingFriendStatus = false;
                    },
                    (response) => {
                        this.isUpdatingFriendStatus = false;
                    }
                )
            },

            removeFriend(){
                this.isUpdatingFriendStatus = true;

                axios.post('/api/friendRequests/remove', {
                    friendId: this.profileData.id
                }).then(
                    (response) => {
                        this.isUpdatingFriendStatus = false;
                    },
                    (response) => {
                        this.isUpdatingFriendStatus = false;
                    }
                )
            },

            saveProfileData(){
                if (this.useMetric) {
                    let totalInches = 0.39 * this.editDetails.metricHeight;
                    this.editDetails.heightFeet = Math.floor(totalInches / 12);
                    this.editDetails.heightInches = totalInches - (this.editDetails.heightFeet * 12);
                }

                axios.post('/api/member', this.editDetails).then(
                    (response) => {
                        this.fetchProfileData((isSuccessful) => {
                            this.editProfileMode = false;
                        });
                    }
                )
            },

            saveBio(){
                axios.post('/api/member/bio', {bio: this.editBioContent}).then(
                    (response) => {
                        this.fetchProfileData((isSuccessful) => {
                            this.editBioMode = false;
                        });
                    }
                )
            },

            yearRange: function (min) {
                let array = [],
                    max = new Date().getFullYear() - 13,
                    j = 0;

                for (let i = min; i <= max; i++) {
                    array[j] = i;
                    j++;
                }

                return array.reverse();
            }
        },

        watch: {
            'profileData'(){
                this.editDetails = {
                    realName: this.profileData.realName,
                    showAge: !!this.profileData.showAge,
                    birthMonth: this.profileData.birthMonth,
                    birthDay: this.profileData.birthDay,
                    birthYear: this.profileData.birthYear,
                    location: this.profileData.location,
                    gender: this.profileData.gender,
                    showHeight: this.profileData.showHeight,
                    heightFeet: this.profileData.heightFeet,
                    heightInches: this.profileData.heightInches,
                    metricHeight: 0
                };

                this.editBioContent = this.profileData.bio;
            },

            'metricHeight'(){
                this.$set(this.editDetails, 'metricHeight', this.metricHeight);
            }
        },

        mounted(){
            setTimeout(() => {
                this.fetchProfileData((isSuccessful) => {
                    if (isSuccessful) {
                        this.fetchFriendStatus();
                    }
                });
            }, 500);
        },

        sockets: {
            'updateFriendStatus'(){
                this.deleteFriendMode = false;
                this.fetchFriendStatus();
            },

            'profilePhotoUploaded'(data){
                if (data.memberId === this.profileData.id) {
                    this.fetchProfileData();
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ProfilePage.vue?1580e323